<script>
import { Line } from 'vue-chartjs'

const fmtBRL  = v => Number(v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
const toDate  = s => new Date(s + 'T00:00:00')
const ddMM    = d => String(d.getDate()).padStart(2,'0') + '/' + String(d.getMonth()+1).padStart(2,'0')
const yyyyMM  = d => d.getFullYear() + '-' + String(d.getMonth()+1).padStart(2,'0')
const sow     = d => { const x = new Date(d); const wd=(x.getDay()+6)%7; x.setDate(x.getDate()-wd); return x }

function granularity(dt1, dt2){
  const diffDays = Math.max(1, Math.round((toDate(dt2) - toDate(dt1)) / 86400000) + 1)
  if (diffDays <= 14)  return 'day'
  if (diffDays <= 120) return 'week'
  return 'month'
}

function aggregate(points, g){
  const acc = new Map()
  for (const p of (points || [])) {
    const d = toDate(p.data)
    let key, label
    if (g === 'day') {
      key = p.data; label = ddMM(d)
    } else if (g === 'week') {
      const s = sow(d); key = 'W:' + s.toISOString().slice(0,10); label = 'sem ' + ddMM(s)
    } else {
      const ym = yyyyMM(d); key = 'M:' + ym; label = ym.slice(5,7) + '/' + ym.slice(0,4)
    }
    const cur = acc.get(key) || { label, total: 0 }
    cur.total += Number(p.valor || 0)
    acc.set(key, cur)
  }
  const entries = Array.from(acc.entries()).sort((a,b)=> a[0].localeCompare(b[0]))
  return {
    labels: entries.map(([,v]) => v.label),
    data:   entries.map(([,v]) => v.total)
  }
}

export default {
  name: 'GraficoLinhaVendasPequeno',
  extends: Line,
  props: {
    points:   { type: Array,  required: true },   // [{ data:'YYYY-MM-DD', valor:Number }]
    dt1:      { type: String, required: true },
    dt2:      { type: String, required: true },
    height:   { type: Number, default: 42 },
    lineColor:{ type: String, default: '#20a8d8' },
    fillArea: { type: Boolean, default: false },
    showTooltips: { type: Boolean, default: false }   // <-- NOVO
  },
  methods: {
    montarGrafico(){
      const g = granularity(this.dt1, this.dt2)
      const { labels, data } = aggregate(this.points, g)

      const ds = [{
        label: 'Vendas',
        data: data.slice(),
        borderWidth: 2,
        borderColor: this.lineColor,
        backgroundColor: this.fillArea ? 'rgba(32,168,216,0.15)' : 'rgba(0,0,0,0)',
        fill: this.fillArea,
        pointRadius: 0,
        lineTension: 0.2
      }]

      this.renderChart(
        { labels, datasets: ds },
        {
          responsive: true, maintainAspectRatio: false, legend: { display: false },
          tooltips: {
            enabled: this.showTooltips,
            mode: 'index', intersect: false,
            callbacks: {
              title: items => labels[items[0].index],
              label: it => fmtBRL(it.yLabel)
            }
          },
          scales: { xAxes: [{ display: false }], yAxes: [{ display: false }] },
          elements: { point: { radius: 0, hitRadius: 8, hoverRadius: 4 } }
        }
      )
    }
  },
  mounted(){ this.montarGrafico() },
  watch: {
    points(){ this.montarGrafico() },
    //dt1(){ this.montarGrafico() },
    //dt2(){ this.montarGrafico() }
  },
  beforeDestroy(){ if (this._chart && this._chart.destroy) this._chart.destroy() }
}
</script>



// WEBPACK FOOTER //
// src/views/movimentos/vendas/GraficoLinhaVendasPequeno.vue